module.exports = __webpack_public_path__ + "assets/img/img-qw-4006b82d.png";